<!--footer-->
<footer class="w-full bg-zinc-900" [class.lg:block]="true" [class.hidden]="!isHomePage()">
  <div class="container">
    <div class="flex flex-col">
      <div class="hidden lg:flex flex-col gap-4 py-10">
        <div>
          <img [src]="logoData()?.value || '/logo-v2.png'" alt="올하우스 로고" class="w-32" />
        </div>
        <div class="flex justify-between items-center">
          <div class="flex flex-col gap-3">
            <div class="flex flex-col gap-1 text-sm text-zinc-300">
              <div class="flex items-center gap-4">
                <p>업체명 : {{ getSettingValue('allhouse_name') || '주식회사 마이스좋은공간' }}</p>
                <p>대표자 : {{ getSettingValue('allhouse_ceo_name') || '위영수' }}</p>
                <p>
                  사업자등록번호 :
                  {{ getSettingValue('allhouse_business_number') || '347-87-02586' }}
                </p>
              </div>

              <div class="flex items-center gap-4">
                <p>
                  TEL :
                  {{ getSettingValue('allhouse_contact') || '1522-1564' }}
                </p>
                <p>Email : {{ getSettingValue('allhouse_email') || 'good-space@naver.com' }}</p>
                <p>주소 : {{ getSettingValue('allhouse_address') || '광주광역시 서구 쌍촌동28번길 1~2F' }}</p>
              </div>
            </div>

            <div class="flex gap-4 text-zinc-200 text-sm items-center">
              <a routerLink="/policy" [queryParams]="{ type: 'use' }" class="cursor-pointer underline">이용약관</a>
              <a routerLink="/policy" [queryParams]="{ type: 'privacy' }" class="cursor-pointer underline"
                >개인정보처리방침</a
              >
              <a routerLink="/policy" [queryParams]="{ type: 'marketing' }" class="cursor-pointer underline"
                >마케팅활용동의</a
              >
            </div>
          </div>
          <app-sns-buttons />
        </div>

        <div class="text-xs font-bold text-zinc-200">
          <p>{{ getSettingValue('allhouse_copyright') || 'ⓒ 2026 마이스좋은공간. All Rights Reserved' }}</p>
        </div>

        <div class="w-full h-px bg-zinc-700"></div>

        <p class="text-xs text-zinc-400 leading-relaxed break-keep">{{ disclaimer }}</p>
      </div>

      <div class="flex lg:hidden flex-col gap-4 py-6 px-4">
        <div>
          <img [src]="logoData()?.value || '/logo-v2.png'" alt="올하우스 로고" class="w-26" />
        </div>
        <div class="flex flex-col gap-1 text-xs text-zinc-300">
          <p>업체명 : {{ getSettingValue('allhouse_name') || '주식회사 마이스좋은공간' }}</p>
          <p>대표자 : {{ getSettingValue('allhouse_ceo_name') || '위영수' }}</p>
          <p>
            사업자등록번호 :
            {{ getSettingValue('allhouse_business_number') || '347-87-02586' }}
          </p>
          <p>
            TEL :
            {{ getSettingValue('allhouse_contact') || '1522-1564' }}
          </p>
          <p>Email : {{ getSettingValue('allhouse_email') || 'good-space@naver.com' }}</p>
          <p>주소 : {{ getSettingValue('allhouse_address') || '광주광역시 서구 쌍촌동28번길 1~2F' }}</p>
        </div>

        <div class="flex gap-4 text-zinc-200 text-xs items-center">
          <a routerLink="/policy" [queryParams]="{ type: 'use' }" class="cursor-pointer underline">이용약관</a>
          <a routerLink="/policy" [queryParams]="{ type: 'privacy' }" class="cursor-pointer underline"
            >개인정보처리방침</a
          >
          <a routerLink="/policy" [queryParams]="{ type: 'marketing' }" class="cursor-pointer underline"
            >마케팅활용동의</a
          >
        </div>

        <app-sns-buttons />

        <div class="text-xs font-bold text-zinc-200">
          <p>{{ getSettingValue('allhouse_copyright') || 'ⓒ 2026 마이스좋은공간. All Rights Reserved' }}</p>
        </div>

        <div class="w-full h-px bg-zinc-700"></div>

        <p class="text-xs text-zinc-400 leading-relaxed break-keep">{{ disclaimer }}</p>
      </div>
    </div>
  </div>
</footer>
